import { render } from "./BotaoExcluir.vue?vue&type=template&id=fb384d56&ts=true"
import script from "./BotaoExcluir.vue?vue&type=script&lang=ts"
export * from "./BotaoExcluir.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__